<h2 mat-dialog-title>Delete Note</h2>
<div mat-dialog-content>
    <p>(Members' notes are only visible to EICDataStream Users within your own organisation)</p>
    <p style="color:red;">This note will be permanently deleted:</p>
    <p>{{ data.memberNote.note }}</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="warn" type="button" (click)="delete()" [disabled]="isDeleting">Permanently Delete</button>
</div>
